<script>
import {BCard, BCardTitle, BRow, BCol} from 'bootstrap-vue'
import {Button} from "@core/components/common";
import RepeatableElementCard from "@core/components/common/RepeatableElementCard.vue";
import LegalIdentity from "@core/components/common/LegalIdentity.vue";

export default {
    components: {LegalIdentity, RepeatableElementCard, BCard, BCardTitle, BRow, BCol, Button},
    props: {
        identities: {
            default() {
                return [];
            }
        }
    },
    methods: {
        add() {
            const identity = {
                type: null,
                value: null
            };
            this.$emit('add', identity);
        },
        remove({item, index}) {
            this.$emit('remove', {item, index});
        },
        identityChange(identity, item) {
            this.$emit('change', {
                identity: identity,
                index: item.index
            })
        }
    },
}
</script>

<template>
    <RepeatableElementCard
        :elements="identities"
        :title="$t('Component(CardLabel):legal-identities')"
        @add="add"
        @remove="remove"
    >
        <template #default="data">
            <LegalIdentity
                :identity="data.item"
                @input="(identity) => identityChange(identity, data)"
            />
        </template>
    </RepeatableElementCard>
</template>
